module.exports = __webpack_public_path__ + "static/media/13.9d918a08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KiaKids/13.png
// module id = 1207
// module chunks = 0